module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAQCAYAAAD9L+QYAAABY0lEQVQ4T7WTPUsDQRCG33cT79IKKtjGwn8gBm1SmNpWsEjkkrtUgr0SwR8gVyR3hYoWgpWFlRALbQz4D1SwMxDQWhO4kZWL5DvEJNPOzPPMzu6yVCotKKVOAaQAzGD8aAAoB0GQpu/71wA2x2d2EW40/BuAMQV4Q8PfASxOAV6j53m7JI+nAN+jhvq+fwJgZ4KCc9u20024fiW3AJITENxXq9VUoVCo/8J1FIvFWaXUI8nlMQTPkUgkYVnWp2b8wcP1LAGoAJj7h+BDRBKO47w0e9vgoWBdRMokzREEdRHZcBznobWnC66Tnudtk7zoPFkfmSil0tlsVte3RU94KDgkeTBsepJHuVxuv1ddX3gouCS5NUBwZdu2zsvIcNd1zVgsdicia53NIlIxTTOZyWS++skHTq6bXNedNwyjQjLeAnkLgmA1n8/XBq1tKDz8A3Gl1BnJFRF5ikajO5ZlvQ67jx+alm4etGprlwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/down1.png
// module id = Dt7w
// module chunks = 1